export default __webpack_public_path__ + "static/media/close.0bcc2a8b.svg";